var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7437 4.75659C13.7538 1.5185 10.6784 0.0343709 7.60301 0.259239C3.07538 0.619027 0.298995 4.62167 0.170854 4.80157L0 5.07141L0.170854 5.34125C0.341709 5.52114 3.41709 9.74866 8.11558 9.97353C8.24372 9.97353 8.37186 9.97353 8.45729 9.97353C11.3191 9.97353 14.0955 8.44442 16.7437 5.38622L17 5.07141L16.7437 4.75659ZM8.15829 9.07405C4.52764 8.89416 1.83668 5.97088 1.11055 5.07141C1.79397 4.17194 4.22864 1.42855 7.68844 1.15871C10.3794 0.933842 13.1558 2.28305 15.8467 5.07141C13.3693 7.81479 10.7638 9.164 8.15829 9.07405Z",
    fill: "#E63335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80957 5.07132C5.80957 6.60042 7.00555 7.85968 8.45781 7.85968C9.91007 7.85968 11.1061 6.60042 11.1061 5.07132C11.1061 3.54222 9.91007 2.28296 8.45781 2.28296C7.00555 2.28296 5.80957 3.54222 5.80957 5.07132ZM8.45781 3.00254C9.56836 3.00254 10.4226 3.94698 10.4226 5.07132C10.4226 6.19566 9.52565 7.1401 8.45781 7.1401C7.38997 7.1401 6.49299 6.19566 6.49299 5.07132C6.49299 3.94698 7.38997 3.00254 8.45781 3.00254Z",
    fill: "#E63335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/ShowPassword.b9c3501ce7159992d5203b85d44f9350.svg";
export { ForwardRef as ReactComponent };